var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M22.823 36.36H13c-3.866 0-7-3.185-7-7.114V14h38v15.246c0 3.929-3.134 7.114-7 7.114h-9.823l3.164 6.433c.37.753.07 1.67-.67 2.046a1.489 1.489 0 0 1-2.013-.682L25 38.753l-2.659 5.404a1.489 1.489 0 0 1-2.012.682 1.536 1.536 0 0 1-.67-2.046l3.164-6.433zm13.173-16.858L36 23.147c0 .561.449 1.016 1.001 1.015.552 0 1-.456.999-1.017l-.006-5.982a1.025 1.025 0 0 0-.286-.832.989.989 0 0 0-.808-.293l-5.903-.005c-.552 0-1 .454-1 1.015-.001.562.446 1.017.998 1.018l3.584.003-5.8 5.88-7.345-3.743a.988.988 0 0 0-1.156.191l-7.983 8.138a1.028 1.028 0 0 0 .002 1.437.989.989 0 0 0 1.414-.002l7.473-7.618 7.343 3.742c.385.196.85.12 1.155-.19l6.314-6.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44D5E9",
    d: "M43 4a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a3 3 0 0 1 3-3h36z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.23c7ac7049eb82c90ffc03aebcfddb4f.svg";
export { ForwardRef as ReactComponent };